"use client";

import React from "react";
import { usePostHog } from "posthog-js/react";
import {
  LEMONADE_AFFILIATE_URL,
  type LemonadeBannerVariant,
  type LemonadeCardVariant,
} from "./lemonade";

type Props = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href" | "target" | "rel" | "onClick"
> & {
  format: "banner" | "card";
  variant: LemonadeBannerVariant | LemonadeCardVariant;
};

const LemonadeAffiliateLink = React.forwardRef<HTMLAnchorElement, Props>(
  ({ format, variant, children, ...props }, ref) => {
    const posthog = usePostHog();

    return (
      <a
        {...props}
        ref={ref}
        href={LEMONADE_AFFILIATE_URL}
        target="_blank"
        rel="sponsored nofollow noreferrer"
        onClick={() => {
          posthog.capture("affiliate_promo_click", {
            affiliate: "lemonade",
            format,
            variant,
            path: window.location.pathname,
          });
        }}
      >
        {children}
      </a>
    );
  },
);

LemonadeAffiliateLink.displayName = "LemonadeAffiliateLink";

export default LemonadeAffiliateLink;
